import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="container-luxe py-32 text-center max-w-lg mx-auto" data-testid="payment-cancel-page">
      <ShoppingBag size={56} strokeWidth={1} className="text-charcoal mx-auto mb-8" />
      <h1 className="h-display text-5xl mb-4">Checkout Cancelled</h1>
      <p className="text-sm text-muted-foreground font-light mb-10">No worries — your bag is saved and waiting for you whenever you're ready.</p>
      <div className="flex gap-4 justify-center">
        <Link to="/cart" className="btn-primary" data-testid="return-cart-btn">Return To Bag</Link>
        <Link to="/shop" className="btn-secondary">Keep Shopping</Link>
      </div>
    </div>
  );
}
